import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { fetchReports, selectReports } from "./reportsSlice"
import { Tooltip, Row, Col, notification } from "antd"
import { QuestionCircleOutlined, FilePdfOutlined, FileTextOutlined } from "@ant-design/icons"
import { Link, useRouteMatch } from "react-router-dom"
import path from "path"
import { selectRoles } from "../userRoles/userRolesSlice"

export default function ReportDashboard() {
    const { url } = useRouteMatch()

    const dispatch = useDispatch()

    const { clientId } = useParams()

    const [init, setInit] = useState(false)

    const reports = useSelector(selectReports)
    const roles = useSelector(selectRoles)

    useEffect(() => {
        if (init) {
            return
        }

        setInit(true)

        dispatch(fetchReports(clientId))
    }, [dispatch, init, clientId])

    const fileIcon = (report) => {
        const type = report.export_type

        switch (type) {
            case "pdf":
                return FilePdfOutlined
            case "csv":
                return FileTextOutlined
            case "csv_and_pdf":
                return FilePdfOutlined
            default:
                console.log("Unknown file type: ", type)
                return null
        }
    }

    return (
        <div>
            <Row gutter={24}>
                {reports.map((r) => {
                    const Icon = fileIcon(r)

                    return (
                        <Col span={12} style={{ marginBottom: "25px" }}>
                            <Link
                                to={(!((roles.includes("muc_admin")|| roles.includes("client_admin")) && r.name == "Trial Balance Report") || roles.includes("super_admin")) ? path.join(url, "..", `${r.id}`, "new") : "#"}
                                key={r.id}
                                onClick={() => {
                                    if(!(!((roles.includes("muc_admin") || roles.includes("client_admin")) && r.name == "Trial Balance Report") || roles.includes("super_admin"))){
                                        notification.error({
                                            message: "Not allowed.",
                                            description: "Your current role does not allow you to create this report.",
                                            duration: 2
                                        })
                                    }
                                }}>
                                <div className="card report-card">
                                    <div className="card-title">
                                        <h2 style={{ display: "inline" }}>
                                            <Icon />
                                            &nbsp;
                                            {r.name}
                                        </h2>
                                        &nbsp;
                                        <Tooltip title={r.description}>
                                            <QuestionCircleOutlined />
                                        </Tooltip>
                                    </div>
                                    <div className="card-content">
                                        <b>Key Items:</b>&nbsp;{r.key_items}
                                    </div>
                                </div>
                            </Link>
                        </Col>
                    )
                })}
            </Row>
        </div>
    )
}
